import db from '../db'
import firebase from '../fb'
import rtdb from '../rtdb'
import { firestoreAction, firebaseAction } from 'vuexfire'

const state = {

};

const getters = {

};

const mutations = {
    
  async matchAsk(state, { payload, commit }) {
    let askPrice = payload.askPrice;
    let asset = payload.asset
    let currency = payload.currency
    let second = payload.second
    let p1B = `${currency}Balance`
    let p2B = `${second}Balance`
    let askAmount = payload.askAmount;
    let askTotal = payload.askTotal;
    let user = firebase.auth().currentUser;
    let fee = payload.fee;

    let  getBuyOrders = async () =>{
        const markers = [];
        await db.collection(payload.asset).doc(payload.currency + payload.second).collection('buyOrders').where('bidPrice', '>=', askPrice).orderBy('bidPrice', 'desc').get()
          .then(querySnapshot => {
            querySnapshot.docs.forEach(doc => {
            markers.push(doc.data());
          });
        });
        return markers;
      }
    let buyOrders =  await getBuyOrders()
      console.log(buyOrders);
    const hasObj = buyOrders.some(a => typeof a == 'object')
    let assetDb = db.collection(payload.asset).doc(payload.currency + payload.second)


    if (hasObj) {

        let pushComission = (commission_data) =>{
            commit('order/commission', commission_data, { root: true });
        }

        let pushExchanged = (exchanged_data) =>{
            commit('order/exchanged', exchanged_data, { root: true });
        }


      for (let i = 0; i < buyOrders.length; i++) {
        let buyOrder = buyOrders[0]
        let userRef = db.collection('users').doc(user.uid)
        let buyerRef = db.collection('users').doc(buyOrder.user_id)
        let buy_order_ref = db.collection(payload.asset).doc(payload.currency + payload.second).collection('buyOrders').doc(buyOrder.id)
        

        if (askPrice <= buyOrder.bidPrice && askAmount < buyOrder.bidAmount) {
            
            try {
                let sub_amount = (field, amount) => {
                    let icrCb = firebase.firestore.FieldValue.increment(-amount);
                    let cB = `${field}Balance`
                    let data = {}
                    data[cB] = icrCb
                    return data
                }

                let add_amount = (field, amount) => {
                    let increase = firebase.firestore.FieldValue.increment(amount);
                    let cB = `${field}Balance`
                    let data_set = {}
                    data_set[cB] = increase
                    return data_set
                }
                await db.runTransaction(async (tx) => {
                    let user_doc = await tx.get(userRef)
                    let currency_balance = user_doc.data()[`${currency}Balance`]
                    console.log(currency_balance);
                        if (currency_balance - askAmount < 0) {
                                swal("Erreur solde", "solde insuffisant", "error", {
                                    button: "ok"
                                });
                                console.log('hello');
                                return
                            }
                    //substract askamount from seller account
                    tx.update(userRef, sub_amount(currency, askAmount))

                    //add the total sell cfa asktotal to seller account
                    tx.update(userRef, add_amount(second, askTotal))

                    //add total sell askamount to buyer btc account

                    tx.update(buyerRef, add_amount(currency, askAmount))
                    // update buyOrder
                    let remaining_bidAmount = buyOrder.bidAmount - askAmount
                    let remaining_bidTotal = (1+fee) * askPrice * remaining_bidAmount
                    let update_remaining_order = {
                        bidAmount: remaining_bidAmount,
                        bidTotal: remaining_bidTotal,
                    }
                    console.log(update_remaining_order);
                    tx.update(buy_order_ref, update_remaining_order)
                  
                });
              
                console.log('Transaction success!');
                let sub_bid_total = (1 + fee) * askAmount * askPrice
                let commission = sub_bid_total- askTotal
                console.log(sub_bid_total, askTotal, commission);

                  let commission_data = {
                    type: 'vente',
                    commission: commission,
                    asset: asset,
                    currency: currency,
                    second: second,
                    maker: buyOrder.user_id,
                    taker: user.uid
      
                  }

                  let exchanged_data = {
                    type: 'vente',
                    asset: asset,
                    currency: currency,
                    second: second,
                    price: askPrice,
                    amount: askAmount,
                    askTotal: askTotal,
                    bidTotal: sub_bid_total,
                    maker: buyOrder.user_id,
                    taker: user.uid
                  }

                  pushComission(commission_data)
                  pushExchanged(exchanged_data)


              } catch (e) {
                console.log('Transaction failure:', e);
              }
              
          break;
        }
        else if (askPrice <= buyOrder.bidPrice && askAmount == buyOrder.bidAmount) {

            try {
                let sub_amount = (field, amount) => {
                    let icrCb = firebase.firestore.FieldValue.increment(-amount);
                    let cB = `${field}Balance`
                    let data = {}
                    data[cB] = icrCb
                    return data
                }

                let add_amount = (field, amount) => {
                    let increase = firebase.firestore.FieldValue.increment(amount);
                    let cB = `${field}Balance`
                    let data_set = {}
                    data_set[cB] = increase
                    return data_set
                }
                await db.runTransaction(async (tx) => {
                    let user_doc = await tx.get(userRef)
                    let currency_balance = user_doc.data()[`${currency}Balance`]
                    console.log(currency_balance);
                        if (currency_balance - askAmount < 0) {
                                swal("Erreur solde", "solde insuffisant", "error", {
                                    button: "ok"
                                });
                                console.log('hello');
                                return
                            }
                    
                     //substract askamount from seller account
                     tx.update(userRef, sub_amount(currency, askAmount))
                            
                     //add the total sell cfa asktotal to seller account
                     tx.update(userRef, add_amount(second, askTotal))

                     //add the total sell amount btc to the buyer btc account
                     tx.update(buyerRef, add_amount(currency, askAmount))

                     //delete buy order
                     tx.delete(buy_order_ref)      
                  
                });
                console.log('Transaction success!');

                let commission = buyOrder.bidTotal - askTotal
                let commission_data = {
                    type: 'vente',
                    asset: asset,
                    currency: currency,
                    second: second,
                    commission: commission,
                    maker: buyOrder.user_id,
                    taker: user.uid
                  }
                let exchanged_data = {
                    type: 'vente',
                    asset: asset,
                    currency: currency,
                    second: second,
                    price: askPrice,
                    amount: askAmount,
                    askTotal: (1 - fee) * askPrice * buyOrder.bidAmount,
                    bidTotal: buyOrder.bidTotal,
                    maker: buyOrder.user_id,
                    taker: user.uid
                  }

                  pushComission(commission_data)
                  pushExchanged(exchanged_data)

              } catch (e) {
                console.log('Transaction failure:', e);
              }
          break;
        }else if (askPrice <= buyOrder.bidPrice && askAmount > buyOrder.bidAmount) {

            try {

                let sub_amount = (field, amount) => {
                    let icrCb = firebase.firestore.FieldValue.increment(-amount);
                    let cB = `${field}Balance`
                    let data = {}
                    data[cB] = icrCb
                    return data
                }

                let add_amount = (field, amount) => {
                    let increase = firebase.firestore.FieldValue.increment(amount);
                    let cB = `${field}Balance`
                    let data_set = {}
                    data_set[cB] = increase
                    return data_set
                }

                let sub_ask_total = (1 - fee) * buyOrder.bidAmount * askPrice


                await db.runTransaction(async (tx) => {
                    let user_doc = await tx.get(userRef)
                    let currency_balance = user_doc.data()[`${currency}Balance`]
                    console.log(currency_balance);
                        if (currency_balance - askAmount < 0) {
                                swal("Erreur solde", "solde insuffisant", "error", {
                                    button: "ok"
                                });
                                return
                            }
                    
                     //substract askamount from seller account
                     tx.update(userRef, sub_amount(currency, buyOrder.bidAmount))

                     //add buyTotal cfa to the seller account
                     tx.update(userRef, add_amount(second, sub_ask_total))

                     //add the total buy amount btc to the buyer btc account
                     tx.update(buyerRef, add_amount(currency, buyOrder.bidAmount))

                     //delete buyOrder
                     tx.delete(buy_order_ref)
                  
                });
                console.log('Transaction success!');

                    let remaining_askAmount = askAmount - buyOrder.bidAmount
                    let new_askTotal = (1 - fee) * remaining_askAmount* askPrice
  
                    let payload = {
                      askPrice: askPrice,
                      askAmount: remaining_askAmount,
                      askTotal: new_askTotal,
                      fee: fee,
                      asset: asset,
                      currency: currency,
                      second: second
                    }
                    console.log(payload);

                 commit('matchAsk', { payload, commit })

                let commission = buyOrder.bidTotal - sub_ask_total
                let commission_data = {
                    type: 'vente',
                    asset: asset,
                    currency: currency,
                    second: second,
                    commission: commission,
                    maker: buyOrder.user_id,
                    taker: user.uid
                  }


                  let exchanged_data = {
                    type: 'vente',
                    asset: asset,
                    currency: currency,
                    second: second,
                    price: askPrice,
                    amount: buyOrder.bidAmount,
                    bidTotal: buyOrder.bidTotal,
                    askTotal: (1 - fee) * askPrice * buyOrder.bidAmount,
                    maker: buyOrder.user_id,
                    taker: user.uid
                  }

                  pushComission(commission_data)
                  pushExchanged(exchanged_data)

              } catch (e) {
                console.log('Transaction failure:', e);
              }
      
            break;
          }
        else {
          commit('pushAsk', payload)
          break;
        }
      }
    } else {
      commit('pushAsk', payload)
    }
},

async pushAsk(state, payload) {
    let user = firebase.auth().currentUser;
    let userRef = db.collection('users').doc(user.uid)
    let ask_ref = db.collection(payload.asset).doc(payload.currency + payload.second).collection("sellOrders").doc()
    let currency = payload.currency

    let ask = {
      id: ask_ref.id,
      user_id: user.uid,
      askTotal: payload.askTotal,
      askAmount: payload.askAmount,
      askPrice: payload.askPrice,
      created_at: firebase.firestore.FieldValue.serverTimestamp()
    }

    try {
        let sub_amount = (field, amount) => {
            let icrCb = firebase.firestore.FieldValue.increment(-amount);
            let cB = `${field}Balance`
            let data = {}
            data[cB] = icrCb
            console.log(data);
            return data
        }

        await db.runTransaction(async (tx) => {
            let user_doc = await tx.get(userRef)
            let currency_balance = user_doc.data()[`${currency}Balance`]
            if (currency_balance - payload.askAmount < 0) {
                swal("Erreur solde", "solde insuffisant", "error", {
                    button: "ok"
                });
                console.log('hello');
                return
            }
            //substract currency sell balance form user account
            tx.update(userRef, sub_amount(currency, payload.askAmount))

            //set ask order to db
            if (payload.askTotal >= 200) {
                console.log('hii');
                tx.set(ask_ref, ask)
            } else {
                const increment = firebase.firestore.FieldValue.increment(payload.askTotal);
                const storyRef = db.collection('perso').doc('sq0uDLaLRWWmdJd3srxk');
                storyRef.update({small_orders : increment });
            }
        });
      
        console.log('Transaction success! pushAsk' );
      } catch (e) {
        console.log('Transaction failure:', e);
      }
    
  },

    
};

const actions = {
    ask({ commit }, payload) {

        if (payload.askTotal > 0 && payload.askPrice > 0 && payload.askAmount > 0) {
          if (payload.askTotal === (1 - payload.fee) * payload.askPrice * payload.askAmount) {
            commit('matchAsk', { payload, commit })
          } else {
            swal("Soucis avec l'ordre !!!", "les valeurs ne correspondent pas!", "error", {
              button: "ok"
            });
          }
    
        } else {
          swal("Non Non Non !!!", "Pas de valeur négative ici!", "error", {
            button: "pardon!"
          });
        }
    
      },
   

};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
